import React from "react";
import { useNavigate } from "react-router-dom";

import { BILLING_CARDS } from "../cards";
import { BillingSettingsCard } from "../components/BillingSettingsCard";

export const Billing = () => {
  const navigate = useNavigate();
  // ProCharted's own plan is the separate Settings > Subscription tab (owner 2026-10-25).
  const cards = BILLING_CARDS;

  return (
    <div className={"py-6"}>
      <div
        className={"mb-6 flex items-center justify-between gap-4 font-Manrope"}>
        <div className={"text-2xl font-semibold"}>Billing Settings</div>
      </div>
      <div className={"grid grid-cols-[420px_420px] gap-2"}>
        {cards.map((card) => (
          <BillingSettingsCard
            title={card.label}
            description={card.description}
            icon={card.icon}
            onClick={() => navigate(card.path)}
            key={card.path ?? "index"}
          />
        ))}
      </div>
    </div>
  );
};
